import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AuthRedirect = () => {
	const { token } = useAuth();
	const location = useLocation();

	const publicRoutes = ["/", "/login", "/register"];

	return token && publicRoutes.includes(location.pathname) ? (
		<Navigate to="/dashboard" replace />
	) : (
		<Outlet />
	);
};

export default AuthRedirect;
